import { apiClient } from "@nimbus-erp/api-client";
import { useQueryClient } from "@tanstack/react-query";
import { Alert, Button, Card, Input, Space, Typography } from "antd";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { firstBusinessRoute } from "../utils/navigationAccess";
import { announceErpSessionChange } from "../utils/sessionChange";

export function PlatformAccessPage() {
  // Remove the fragment synchronously, before rendering links or making requests.
  const [token, setToken] = useState(() => {
    const value =
      new URLSearchParams(window.location.hash.slice(1)).get("token") ?? "";
    return value;
  });
  useLayoutEffect(() => {
    window.history.replaceState(null, "", window.location.pathname);
  }, []);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const started = useRef(false);
  const initialToken = useRef(token);
  const navigate = useNavigate();
  const client = useQueryClient();
  const { setUser, setInitialized } = useAuthStore();
  const exchange = async (value: string) => {
    if (started.current) return;
    started.current = true;
    setPending(true);
    setError("");
    try {
      const session = await apiClient.exchangePlatformAccess(value.trim());
      client.clear();
      client.setQueryData(["session"], session);
      setUser(session);
      setInitialized(true);
      announceErpSessionChange();
      setToken("");
      navigate(firstBusinessRoute(session.permissions), { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : "访问失败，请重新生成凭证");
      started.current = false;
      setPending(false);
      setToken("");
    }
  };
  useEffect(() => {
    if (initialToken.current) void exchange(initialToken.current);
  }, []);
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#f4f7fb",
        padding: 24,
      }}
    >
      <Card style={{ maxWidth: 520, width: "100%" }}>
        <Space orientation="vertical" size={20} style={{ width: "100%" }}>
          <Typography.Title level={3}>平台进入企业</Typography.Title>
          <Alert
            type="info"
            title="凭证有效24小时，仅能使用一次"
            description="请输入平台签发的凭证。访问会保留平台操作人身份；到期或撤销后会话失效。"
          />
          {error && <Alert type="error" title={error} showIcon />}
          <Input.Password
            aria-label="企业访问凭证"
            autoComplete="off"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="粘贴访问凭证"
            disabled={pending}
          />
          <Button
            type="primary"
            block
            loading={pending}
            disabled={!token.trim()}
            onClick={() => void exchange(token)}
          >
            进入企业
          </Button>
          <Button
            type="link"
            onClick={() => navigate("/login", { replace: true })}
          >
            返回企业账号登录
          </Button>
        </Space>
      </Card>
    </main>
  );
}
